import { Circle } from "shared/components/Circle";
import { Flex, Text, tokens } from "shared/components/Spor";
import { useThemeSemantic } from "shared/theme/themeSemantic";
import { Semantics } from "shared/utils/semantics";

interface StatContainerProps {
  semantics: Semantics;
  title: string;
  value: number;
}

export const StatContainer = ({
  semantics,
  title,
  value,
}: StatContainerProps) => {
  const theme = useThemeSemantic(semantics);
  return (
    <Flex
      alignItems="center"
      width="100%"
      height="54px"
      backgroundColor={theme.colorBackgroundTertiary}
      p={tokens.default.size.spacing[2]}
      borderRadius="6px"
    >
      <Circle
        size="12px"
        bg={theme.colorSemanticFillPulse}
        borderColor={theme.colorSemanticOutline}
        borderWidth="1px"
      />
      <Text
        color="text"
        lineHeight={1}
        textAlign="center"
        ml={tokens.default.size.spacing[1.5]}
      >
        {title}
      </Text>
      <Text fontWeight="bold" fontSize="md" ml="auto">
        {value}
      </Text>
    </Flex>
  );
};
